import { RefObject, createContext } from 'react';

export const AppScrollPortalContext = createContext<
  RefObject<HTMLDivElement> | undefined
>(undefined);
